// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// 加载样式
import './style/characters.css'
import '@/style/index.scss'

import dayjs from 'dayjs';
Vue.prototype.dayjs = dayjs;

// 这里设置
import axios from 'utils/axios'
Vue.prototype.$http = axios
if (process.env.NODE_ENV === 'testing') {
  Vue.prototype.UploadUrl = '/gateway/EPM-CORE-SERVICE/'
} else if (process.env.NODE_ENV === 'production') {
  Vue.prototype.UploadUrl = 'https://epm.tentcoo.com/gateway/EPM-CORE-SERVICE/'
} else {
  // Vue.prototype.UploadUrl = 'https://epm.tentcoo.com:31000/EPM-CORE-SERVICE/'
  Vue.prototype.UploadUrl = 'http://192.168.19.216:31000/EPM-CORE-SERVICE/'
}


/**全局EventBus事件总线*/
Vue.prototype.$EventBus = new Vue()

// 导入全局样式
import './assets/css/global.css'
import echarts from 'echarts'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 注册element-ui
Vue.use(ElementUI)
Vue.prototype.$echarts = echarts

import VueQuillEditor from 'vue-quill-editor'

// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor)

// 防止重复点击事件 （3s内重复请求无效）
Vue.directive('preventReClick', {
  inserted: function (el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        setTimeout(() => {
          el.disabled = false
        }, binding.value || 3000)
      }
    })
  }
});
/**权限指令**/
// Vue.directive('has', {
//   bind: function (el, binding) {
//     if (!Vue.prototype.$_has(binding.value)) {
//       el.parentNode.removeChild(el);
//     }
//   }
// });
// 用法  ↑↑↑&↓↓↓   <el-button @click="delItem" v-has="'sys_user_delete'">删除</el-button> ↑↑↑&↓↓↓
// 权限检查方法
Vue.prototype.$_has = function (value) {
  // debugger
  let isExist = false;
  let btnPermissions = JSON.parse(localStorage.getItem('funPermissions')) // 按钮权限
  let projectId = localStorage.getItem('projectId') // 项目id
  let projectAuthority = JSON.parse(localStorage.getItem('projectAuthority')) // 项目权限
  let adminFlag = localStorage.getItem('adminFlag') // 超级管理员标识
  let projectItem = []
  if (adminFlag === "1") { // 超级管理员所有权限
    return true
  }
  //  debugger;
  // console.log('权限',projectAuthority)
  if (!projectAuthority || projectAuthority == undefined || projectAuthority == null || projectAuthority == "null") {
    projectItem = []
  } else {
    projectItem = projectAuthority
    // let projectPermissions = JSON.parse(projectAuthority); // 转换成对象
    // for (let i = 0; i < projectPermissions.length; i++) {
    //   if (projectPermissions[i].projectId === projectId) {
    //     projectItem = projectPermissions[i].items;
    //     break;
    //   }
    // }
  }

  if (!btnPermissions || btnPermissions == undefined || btnPermissions == null) {
    return false;
  }
  if (btnPermissions.indexOf(value) > -1 || (projectItem.length > 0 && projectItem.indexOf(value) > -1)) { //则包含该元素
    isExist = true;
  }

  return isExist;
};
// 测试↓↓↓
Vue.prototype.$_phas = function (value) {
  // debugger
  let isExist = false;
  let projectAuthority = localStorage.getItem('projectAuthority') // 项目权限
  if (!projectAuthority || projectAuthority == undefined || projectAuthority == null) {
    return false;
  }
  if (projectAuthority.indexOf(value) > -1) { //则包含该元素
    isExist = true;
  }
  return isExist;
};


//  出现 Uncaught (in promise) undefined （使用（二））
// （一） 在项目目录下运行 npm i vue-router@3.0 -S 即可。
// （二） 解决路由点击菜单时 添加如下代码
import Router from 'vue-router'
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

// 获取通行证后再通过公钥对密码进行加密
import {
  JSEncrypt
} from 'jsencrypt'
Vue.prototype.$getCode = function (pwd, publicKey) {
  let encrypt = new JSEncrypt()
  encrypt.setPublicKey(publicKey)
  let data = encrypt.encrypt(pwd)
  return data
}

Vue.config.productionTip = false
import '@/common' // 配置全局

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js